export const notFound = {
  heading: 'This page has not been generated',
  description: 'Tell me more about this page, so I can generate it',
};
